import './_wishlist-tooltip.scss';
import component from './wishlist-tooltip';

export default component;
